import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Form, Search } from 'semantic-ui-react'
import { ORGANIZATIONS_AUTOCOMPLETE } from '../../../../../graphql/organizations'

const Autocomplete = ({
    onChange,
    value,
    onSelect,
    readOnly,
    exclude,
    ...rest
}) => {
    const [results, setResults] = useState([])

    const { loading } = useQuery(ORGANIZATIONS_AUTOCOMPLETE, {
        variables: { query: value },
        onCompleted: (data) => {
            const autocompleteResults = data.organizationsAutocomplete
                .filter((result) => !exclude.includes(result.id))
                .map((result) => ({
                    id: result.id,
                    title: result.name,
                    organization: result,
                }))

            setResults(autocompleteResults)
        },
    })

    const setSelection = (query, organizationId, organization = null) => {
        onChange(query)
        onSelect({ organizationId, organization })
    }

    if (readOnly) {
        return (
            <Form.Input
                {...rest}
                icon={{
                    name: 'close',
                    link: true,
                    color: 'red',
                    onClick: () => setSelection('', null),
                }}
                value={value}
                readOnly
            />
        )
    }
    return (
        <Form.Field
            required={rest.required}
            width={rest.width}
            error={rest.error}
        >
            <Search
                fluid
                showNoResults={false}
                minCharacters={3}
                loading={loading}
                placeholder={rest.placeholder}
                onSearchChange={(e, { value }) => onChange(value)}
                onResultSelect={(e, { result }) =>
                    setSelection(result.title, result.id, result.organization)
                }
                results={results}
                value={value}
            />
        </Form.Field>
    )
}

export default Autocomplete
